import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'gatsby';

import { SERVICES_ROUTE } from '../../routes';

import awsCloud from './aws-cloud.svg';

const AwsServicesCard = () => {
  return (
    <Link to={SERVICES_ROUTE} className="AwsServicesCard">
      <Card>
        <CardBody>
          <div className="AwsServicesCard__icon">
            <img src={awsCloud} alt="aws cloud" />
          </div>

          <div className="AwsServicesCard__details">
            <h4 className="AwsServicesCard__title">AWS Cloud Services</h4>
            <div className="AwsServicesCard__desc">
              Stream lined best practice cloud and custom-built development solutions from our world-class team
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  );
};

export default AwsServicesCard;
